<template>
  <div class="goods_add">
    <el-card>

        <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"

        >
            <el-form-item label="中文名称" prop="cn_name">
                <el-input v-model="ruleForm.cn_name"></el-input>
            </el-form-item>
            <el-form-item label="英语名称" prop="en_name">
                <el-input v-model="ruleForm.en_name"></el-input>
            </el-form-item>
            <el-form-item label="角色状态" prop="state">

                <el-select v-model="ruleForm.state" placeholder="请选择">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <div class="mt-20"></div>

            <el-form-item class="quill-editor-top">
                <div  v-if="is_edit==false">
                    <el-button
                            type="primary"
                            @click="submitForm('ruleForm')"

                    >添加角色</el-button  >
                    <el-button @click="resetForm('ruleForm')" ref="ruleForm">重置</el-button>
                </div>
                <div v-else>
                    <el-button
                            type="primary"
                            @click="submitForm('ruleForm')"

                    >编辑角色</el-button  >
                    <el-button @click="cancel" ref="ruleForm">放弃</el-button>
                </div>
            </el-form-item>
        </el-form>
    </el-card>

    <el-card style="margin-top: 10px">



        <el-table
                :data="roles_data.data"
                style="width: 100%">
            <el-table-column
                    label="中文名称"
                    width="180">
                <template slot-scope="scope">

                    <span style="margin-left: 10px">{{ scope.row.cn_name }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="英文名称"
                    width="180">
                <template slot-scope="scope">
                    <div slot="reference" class="name-wrapper">
                        {{ scope.row.en_name }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="操作">
                <template slot-scope="scope">


                    <el-button
                            v-if="scope.row.state=='0' && scope.row.en_name!='super'"
                            size="mini"
                            type="primary"
                            @click="updateState(scope.row,1)">启用</el-button>
                    <el-button
                            v-if="scope.row.state=='1' && scope.row.en_name!='super'"
                            size="mini"
                            type="warning"
                            @click="updateState(scope.row,0)">禁用</el-button>
                    <el-button
                            v-if="scope.row.en_name!='super'"
                            size="mini"
                            @click="edit(scope.row,'edit')">编辑</el-button>
                    <el-button
                            v-if="scope.row.en_name!='super'"
                            size="mini"
                            @click="showMenu(scope.$index, scope.row)">配置</el-button>
                    <el-button v-if="scope.row.en_name!='super'"
                            size="mini"
                            type="danger"
                            @click="deleteRole(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>


    </el-card>

  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
        is_edit:false,

        type:"add",
        options:[
            {
                value: '1',
                label: '启用'
            }, {
                value: '0',
                label: '禁用'
            }
        ],


      id: 0,

      ruleForm: {
        cn_name: "",

        en_name: "",
        state:"",

      },


      rules: {
        cn_name: [
          {
            required: true,
            message: "请输入中文名称",
            trigger: "blur",
          },
        ],
          en_name: [
              {
                  required: true,
                  message: "请输入英文名称",
                  trigger: "blur",
              },
          ],
          state: [
              {
                  required: true,
                  message: "请选择状态",
                  trigger: "blur",
              },
          ],
      },
    };
  },
  computed: {
    ...mapState({
        roles: (state) => state.roles.result,
        roles_data: (state) => state.roles.data,
    }),
  },
  methods: {
    ...mapActions({
      getRolesIndexAction: "getRolesIndexAction",
      addRolesDataAction: "addRolesDataAction",
      editRolesDataAction:"editRolesDataAction",
      deleteRolesDataAction:"deleteRolesDataAction"

    }),

      cancel(){
          this.is_edit=false
          this.type=="add"
          this.val=''
          this.ruleForm.cn_name=""
          this.ruleForm.en_name=""
          this.ruleForm.state=''
      },
      showMenu(index, row) {

          this.$router.push({name:"roles_menu",params:{id:row['id']}})
          console.log(index, row);
      },
      edit(row,type) {

          this.is_edit=true
          this.ruleForm.cn_name=row.cn_name
          this.ruleForm.en_name=row.en_name
          this.id=row.id
          this.type=type

          this.ruleForm.state=String(row.state)

      },
      deleteRole(row) {
        this.deleteRolesDataAction({id:row.id})
      },

    saveData() {
        if(this.type=="add"){
            this.addRolesDataAction({
                en_name: this.ruleForm.en_name,
                cn_name: this.ruleForm.cn_name,
                state:this.ruleForm.state
            });
        }
        if(this.type=="edit"){
            this.editRolesDataAction({

                en_name: this.ruleForm.en_name,
                cn_name: this.ruleForm.cn_name,
                state:this.ruleForm.state,
                id:this.id,
                type:this.type
            })
        }




    },
      updateState(row,val){

          this.editRolesDataAction({
              state: val,
              id: row.id,
              type: "state"
          })

      },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          this.$message("请输入正确信息");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    init_data(){

        this.ruleForm.cn_name = "";
        this.ruleForm.state = "";
        this.ruleForm.en_name = "";
        this.id = 0;
        this.is_edit = false;
        this.type= "add";
        this.getRolesIndexAction({})
    }
  },
  created() {
    this.getRolesIndexAction({});
  },
  watch: {

      roles(newdata, olddata) {

      if (newdata.code == 301) {

          this.$message({
              message: '角色添加成功',
              type: 'success'
          });

          this.init_data()
      }
      if (newdata.code == 302) {

          this.$message({
              message: '角色更新成功',
              type: 'success'
          });
        this.init_data()
      }
      if (newdata.code == 303) {
          this.$message({
              message: '角色状态更新成功',
              type: 'success'
          });
         this.init_data()
      }
          if (newdata.code == 304) {
              this.$message({
                  message: '角色删除成功',
                  type: 'success'
              });
             this.init_data()
          }


      console.log(newdata, olddata);
    },
  },
};
</script>



<style>


.avatar-uploader .el-upload {
  border: 1px dashed #260a0a;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.title_bg {
  background-color: #f5fffa;
  padding: 10px;
}

.el-form-item__content {
  margin-left: 30px;
}
</style>
